/**
 * Shared auth models for UPS1 self-hosted authentication.
 * Used by both web and NativeScript apps as an Auth0 replacement.
 */

export interface AuthTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token?: string;
  scope?: string;
}

export interface AuthTokenInfo {
  accessToken: string;
  refreshToken: string | null;
  expiresAt: number; // epoch ms
  userId: string;
  email: string;
  displayName: string;
  adUserName: string | null;
}

export interface LoginCredentials {
  /** AD username or email */
  username: string;
  password: string;
  /** 'ad' for Active Directory login, 'local' for password-based login */
  method: 'ad' | 'local';
}

export interface AuthConfig {
  /** Entra ID tenant ID */
  tenantId: string;
  /** Entra ID client (app registration) ID for this mobile/web app */
  clientId: string;
  /** Software Security API base URL for local auth fallback */
  securityApiBaseUrl: string;
  /** Entra ID scope for token requests (ROPC / refresh grants) */
  scope: string;
  /** Override the Entra token endpoint URL (for web proxy to avoid CORS) */
  tokenEndpointOverride?: string;
  /**
   * Custom-scheme redirect URI for the interactive (system-browser) AD sign-in
   * (WI #31089). Must exactly match a public-client redirect registered on the
   * Entra app, e.g. `com.universalplant.rynsroost://callback`.
   */
  redirectUri?: string;
  /**
   * Scopes requested by the interactive AD sign-in. When omitted the service
   * defaults to `openid profile offline_access user.read api://<clientId>/Access.All`
   * (offline_access is required so a refresh token comes back for silent renew).
   */
  interactiveScopes?: string[];
  /** Override the Entra authorize endpoint URL (parallel to tokenEndpointOverride). */
  authorizeEndpointOverride?: string;
}

export const DEFAULT_AUTH_CONFIG: AuthConfig = {
  tenantId: '664c23fd-3e18-4bd3-a217-c85831125998',
  clientId: 'a8243299-2012-4c7d-af23-0cc138360efa', // Ryns Roost Mobile (Entra)
  securityApiBaseUrl: 'https://software-security-api.universalplant.com',
  scope: 'https://graph.microsoft.com/.default',
  redirectUri: 'com.universalplant.rynsroost://callback',
};
